import React, { useState, useEffect } from "react";
import fire from "../../helpers/db";
import MaterialTable from "material-table";
import XLSX from "xlsx";
import "./Pretest.css";
import Imgsiswa from "../guruu.png"
const Pretest = () => {
    const [user, setUser] = useState([]);
	useEffect(() => {
		const db = fire.firestore();
		const userinfo = [];
		db.collection("pretest")
			.get()
			.then((res) => {
				res.forEach((action) => {
					userinfo.push(action.data());
				});
				setUser(userinfo);
			});	
	}, []);

	const columns = [
		{ title: "Nama", field: "nama" },
		{ title: "Kelas", field: "sekolah", align: "center" },
		{ title: "Nilai", field: "nilai", align: "center" },
	];
	const downloadExcel = () => {
		alert("File akan di download 'klik ok'");
		const newData = user.map((row) => {
			delete row.tableData;
			return row;
		});
		const workSheet = XLSX.utils.json_to_sheet(newData);
		const workBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workBook, workSheet, "Nilai Pretest");
		let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
		XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
		XLSX.writeFile(workBook, "NilaiPretest.xlsx");
	};
	const options = {
		position: "relative",
		zIndex: -100,
		headerStyle: {
			backgroundColor: "#40bf80",
			color: "white",
		},
	};
  return (
    <div className="container mt-2">
            <div className="text-center">
				<h5 style={{ color: "rgba(75,178,115,0.9)" }}>Daftar Nilai Pretest</h5>
			</div>
			{/* <div className="row mt-2 mb-2">
				<div className="col-sm-6">	
				<div className="card bg-success">
				<div className="h6 text-white text-center">Jumlah siswa yang di atas kkm : {user.filter(user => user.nilai >= 70).length}</div>
				</div>
				</div>
				<div className="col-sm-6">
				<div className="card bg-danger text-center">
			<div className="h6  text-white">Jumlah siswa yang di bawah kkm : {user.filter(user => user.nilai < 70).length} </div>
				</div>
				</div>
			</div> */}
			<div className="row">
				<div className="col-sm-6">
					<div className="card" style={{maxWidth:'540px'}}>
						<div className="row g-0">
							<div className="col-md-4">
							<img src={Imgsiswa} className="img-fluid rounded-start" alt="img" style={{backgroundColor:'#b3ffd9'}}/>
							</div>
							<div className="col-md-8">
								<div className="card-body">
									<div className="card-title alert alert-success h6">
										Jumlah siswa
									</div>
									<div className="card-text">Yang memiliki nilai di atas KKM : {user.filter(user => user.nilai >= 70).length} </div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-6">
				<div className="card" style={{maxWidth:'540px'}}>
						<div className="row g-0">
							<div className="col-md-4">
							<img src={Imgsiswa} className="img-fluid rounded-start" alt="img" style={{backgroundColor:"#ff9999"}}/>
							</div>
							<div className="col-md-8">
								<div className="card-body">
									<div className="card-title alert alert-danger h6">
										Jumlah siswa
									</div>
									<div className="card-text">Yang memiliki nilai di bawah KKM : {user.filter(user => user.nilai < 70).length} </div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <MaterialTable
				columns={columns}
				data={user}
				options={options}
				actions={[
					{
						icon: () => <button className="btn btn-success">Export</button>,
						tooltip: "Export ke Excel",
						onClick: () => downloadExcel(),
						isFreeAction: true,
					},
				]}
				title="Tabel Nilai Siswa"
			/>
            	<div className="mt-3 mb-4">
				<div className="text-center h5">Pilihan Siswa Pada Pretest</div>
				<div className="d-flex justify-content-center">
					<div style={{overflowX:'auto'}}>
				<table className="tg" data-sort-name="nama" data-sort-order="desc">
					<thead>
						<tr className="heading">
							<th style={{fontSize:'22px'}} rowSpan={2}>
								Nama
							</th>
							<th className="tg-c3ow" colSpan={20}>
								Jawaban
							</th>
						</tr>
						<tr>
							<th className="tg-0lax"style={{textAlign:'center'}}>no1</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no2</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no3</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no4</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no5</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no6</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no7</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no8</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no9</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no10</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no11</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no12</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no13</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no14</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no15</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no16</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no17</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no18</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no19</th>
							<th className="tg-0lax"style={{textAlign:'center'}}>no20</th>
						</tr>
					</thead>
					<tbody>
						{user.map((action, index) => (
							<tr data-field="nama">
								
								<td>{action.nama}</td>
								{action.picked.map((item, index)=>(
									<td style={item.correct ? {backgroundColor:'#33ff99'} : {backgroundColor:'#ff4d4d'}  
									}>{item.op}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
					</div>
				</div>
			</div>
    </div>
  )
}

export default Pretest